import { render, staticRenderFns } from "./ResumoAcordoConsorcio.vue?vue&type=template&id=9cff9e12"
import script from "./ResumoAcordoConsorcio.vue?vue&type=script&lang=js"
export * from "./ResumoAcordoConsorcio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports